import { jsx as _jsx } from "react/jsx-runtime";
import { FlowNode, flowNodeColor, NodeTypeComponent } from 'fable/flowEditor';
import { AutomationNodeTypes } from 'hocs';
import { noModal } from '../modals';
export class StopNode extends NodeTypeComponent() {
    render() {
        return (_jsx(FlowNode, { color: StopNode.color, icon: StopNode.icon, label: StopNode.label }));
    }
}
StopNode.icon = 'close';
StopNode.label = 'End automation';
StopNode.color = flowNodeColor.red;
StopNode.ActionModal = noModal(AutomationNodeTypes.STOP);
StopNode.actionTrigger = { type: AutomationNodeTypes.STOP };
StopNode.updateConnection = (node) => {
    return node;
};
